import {
  TBctxItemWithoutSize,
  TBCTXKeys,
  TBCTXKeysWithoutSize,
  TRectifiedBCTXInfo,
  TRESPONSE_ToBeRectifiedListing,
} from '@monorepo/types';
import * as moment from 'moment';
import { ModifiersZTableModel } from '../../../table.modifier';
import { TTableCellTree } from '../../../table.type';
function getDisplayName(item: TBctxItemWithoutSize[], key: TBCTXKeysWithoutSize) {
  const index = item.findIndex(({ k }) => k === key);
  return index > -1 ? item[index].v : '--';
}
export const TO_BE_RECTIFIED_LISTING_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_ToBeRectifiedListing['records'],
    orderKeys: TBCTXKeysWithoutSize[],
    bctxKeysToDisplayMap: Record<TBCTXKeys, string>,
    rectifiedBCTXKeysInfo: Record<string, TRectifiedBCTXInfo>,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          ...orderKeys.map((keyWithoutSize) => {
            return {
              type: 'TEXT_CELL',
              text: bctxKeysToDisplayMap[keyWithoutSize],
            } as TTableCellTree;
          }),
          {
            type: 'TEXT_CELL',
            text: bctxKeysToDisplayMap['size'],
          },
          {
            type: 'TEXT_CELL',
            text: 'DATE',
          },
        ],
        select: {
          position: 'END',
          isMulti: true,
          size: 'LARGE',
        },
      },
      (item) => {
        return {
          type: 'ROW',
          rowSelectionInfo: {
            isSelected: false,
            isDisabled: rectifiedBCTXKeysInfo[item.key] ? true : false,
          },
          rowItem: item,
          cells: [
            ...orderKeys.map((keyWithoutSize) => {
              return {
                type: 'TEXT_CELL',
                text: getDisplayName(item.bctx, keyWithoutSize),
              } as TTableCellTree;
            }),
            {
              type: 'TEXT_CELL',
              text: item.size,
            },
            {
              type: 'TEXT_CELL',
              text: moment(new Date(item.datetime)).format('YYYY-MM-DD'),
            },
          ],
        };
      },
    );
  },
};
